<ng-template #confirmDialog let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ title }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('X click')"></button>
  </div>
  <div class="modal-body">
    <p>{{ prompt }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" ngbAutofocus (click)="onAccept()">{{ acceptButtonCaption }}</button>
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">{{ cancelButtonCaption }}</button>
  </div>
</ng-template>
